interface LoginProgressProps {
  currentStep: number;
  totalSteps: number;
  stepMessage: string;
  isVisible: boolean;
}

const steps = [
  'Conectando con google...',
  'Verificando credenciales...',
];

export default function LoginProgress({ currentStep, totalSteps, stepMessage, isVisible }: LoginProgressProps) {
  if (!isVisible) return null;

  const progress = (currentStep / totalSteps) * 100;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-[9999]">
      <div className="bg-white rounded-3xl p-8 shadow-2xl max-w-md w-full mx-4 border border-white/20">
        {/* Header */}
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-[#f7ebd6] rounded-full flex items-center justify-center mx-auto mb-4">
            <div className="w-8 h-8 border-4 border-[#2C4358]/20 border-t-[#2C4358] rounded-full animate-spin"></div>
          </div>
          <h3 className="text-xl font-bold text-[#2C4358] mb-2">Iniciando sesión</h3>
          <p className="text-[#85929e] text-sm">{stepMessage}</p>
        </div>

        {/* Progress Bar */}
        <div className="mb-6">
          <div className="flex justify-between text-xs text-[#85929e] mb-2">
            <span>Progreso</span>
            <span>{Math.round(progress)}%</span>
          </div>
          <div className="w-full bg-[#e9ecef] rounded-full h-2 overflow-hidden">
            <div 
              className="h-full bg-gradient-to-r from-[#f7ebd6] to-[#2C4358] rounded-full transition-all duration-500 ease-out"
              style={{ width: `${progress}%` }}
            ></div>
          </div>
        </div>

        {/* Steps */}
        <div className="space-y-3">
          {steps.map((step, index) => (
            <div 
              key={index}
              className={`flex items-center space-x-3 p-3 rounded-xl transition-all duration-300 ${
                index < currentStep 
                  ? 'bg-[#f7ebd6]/20 border border-[#f7ebd6]/30' 
                  : index === currentStep 
                    ? 'bg-[#f7ebd6]/10 border border-[#f7ebd6]/20' 
                    : 'bg-[#e9ecef]/50'
              }`}
            >
              <div className={`w-6 h-6 rounded-full flex items-center justify-center text-xs font-bold ${
                index < currentStep 
                  ? 'bg-[#f7ebd6] text-[#2C4358]' 
                  : index === currentStep 
                    ? 'bg-[#f7ebd6]/50 text-[#2C4358] animate-pulse' 
                    : 'bg-[#85929e]/20 text-[#85929e]'
              }`}>
                {index < currentStep ? '✓' : index + 1}
              </div>
              <span className={`text-sm font-medium ${
                index < currentStep 
                  ? 'text-[#2C4358]' 
                  : index === currentStep 
                    ? 'text-[#2C4358]' 
                    : 'text-[#85929e]'
              }`}>
                {step}
              </span>
            </div>
          ))}
        </div>

        {/* Loading Animation */}
        <div className="mt-6 flex justify-center">
          <div className="flex space-x-1">
            <div className="w-2 h-2 bg-[#f7ebd6] rounded-full animate-bounce"></div>
            <div className="w-2 h-2 bg-[#f7ebd6] rounded-full animate-bounce" style={{animationDelay: '0.1s'}}></div>
            <div className="w-2 h-2 bg-[#f7ebd6] rounded-full animate-bounce" style={{animationDelay: '0.2s'}}></div>
          </div>
        </div>
      </div>
    </div>
  );
} 